import GetPgCodeDummyData from "../../../dummy/GetPgCodeDummyData.json";
import SavePgCodeDummyData from "../../../dummy/SavePgCodeDummyData.json";
import UpdatePgCodeDummyData from "../../../dummy/UpdatePgCodeDummyData.json";
import SuccessResponse from "../dto/common/SuccessResponse";
import PgCodeDto from "../dto/pgcode/PgCodeDto";

class FakePgCodeApi {
    getPgCode = async (): Promise<SuccessResponse<PgCodeDto>> => {
        return GetPgCodeDummyData;
    };

    savePgCode = async (): Promise<SuccessResponse<{ idPgCode: number }>> => {
        return SavePgCodeDummyData;
    };

    updatePgCode = async (): Promise<SuccessResponse<{ idPgCode: number }>> => {
        return UpdatePgCodeDummyData;
    };
}

export default FakePgCodeApi;
